import { legacyBreakpoints } from '@carvana/merch-tailwind/breakpoints';

const Background = () => (
  <picture className="absolute bottom-1/2 h-[115%] w-full">
    <source
      srcSet={`${process.env.CVNA_APP_CDN_URL}/merch-assets/rbp/bike-details/topography-desktop.svg`}
      media={`(min-width: ${legacyBreakpoints.l}px)`}
    />
    <source
      srcSet={`${process.env.CVNA_APP_CDN_URL}/merch-assets/rbp/bike-details/topography-tablet.svg`}
      media={`(min-width: ${legacyBreakpoints.m}px)`}
    />
    <img
      className="h-full w-full object-cover"
      src={`${process.env.CVNA_APP_CDN_URL}/merch-assets/rbp/bike-details/topography-mobile.svg`}
      alt="Topography"
    />
  </picture>
);

export default Background;
